var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 13.4922C1.78906 13.9453 2.57031 13.9375 2.99219 13.5078L7.45312 9.04688L11.9141 13.5078C12.3516 13.9453 13.125 13.9453 13.5703 13.4922C14.0234 13.0312 14.0312 12.2734 13.5859 11.8281L9.13281 7.36719L13.5859 2.91406C14.0312 2.46875 14.0312 1.70312 13.5703 1.25C13.1172 0.796875 12.3516 0.796875 11.9141 1.23438L7.45312 5.69531L2.99219 1.23438C2.57031 0.804688 1.78125 0.789062 1.32812 1.25C0.875 1.70312 0.890625 2.48438 1.3125 2.91406L5.78125 7.36719L1.3125 11.8359C0.890625 12.2578 0.875 13.0469 1.32812 13.4922Z",
    fill: "#FF694A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9bb987cb83b1d44ebd52d6cf88eb60cc.svg";
export { ForwardRef as ReactComponent };